import { apiClient } from '../config/api';

// FEAT-042 — "Not a Fit" silent bidirectional hide (MVP-8.8, MVP-18.16).

export interface NotAFitRecord {
  id: string;
  markerId: string;
  targetId: string;
  createdAt: string;
  undoneAt: string | null;
}

interface MarkResponse {
  success: boolean;
  data: NotAFitRecord;
  alreadyExisted: boolean;
}

interface ListResponse {
  success: boolean;
  data: NotAFitRecord[];
}

class NotAFitService {
  async markNotAFit(targetId: string): Promise<NotAFitRecord> {
    const response = await apiClient.post<MarkResponse>('/not-a-fit', { targetId });
    return response.data.data;
  }

  async undoNotAFit(id: string): Promise<NotAFitRecord> {
    const response = await apiClient.delete<{ success: boolean; data: NotAFitRecord }>(
      `/not-a-fit/${id}`
    );
    return response.data.data;
  }

  async listMyNotAFit(): Promise<NotAFitRecord[]> {
    const response = await apiClient.get<ListResponse>('/me/not-a-fit');
    return response.data.data;
  }
}

export const notAFitService = new NotAFitService();
